function isEmptyAttributionParagraph(paragraph) {
  const text = (paragraph.textContent || '')
    .replace(/\u00a0/g, ' ')
    .replace(/[\u200b\u200c\u200d\ufeff]/g, '')
    .trim();

  if (text) return false;
  return !paragraph.querySelector('img, video, audio, iframe, table, ul, ol, blockquote, hr');
}

function isEmptyResourceRowTitleParagraph(paragraph) {
  return isEmptyAttributionParagraph(paragraph);
}

export function serializePostEditorHtml(html) {
  if (!html || typeof window === 'undefined' || typeof document === 'undefined') return html;

  const template = document.createElement('template');
  template.innerHTML = html;

  template.content.querySelectorAll('blockquote.ps-pathstone-quote').forEach((quote) => {
    const attribution = quote.querySelector(':scope > p[data-ps-quote-role="attribution"]');
    if (attribution && isEmptyAttributionParagraph(attribution)) {
      attribution.remove();
    }
  });

  template.content.querySelectorAll('tr[data-resource-row]').forEach((row) => {
    const cell = row.querySelector('td:last-child');
    if (!cell) return;

    const titleParagraphs = cell.querySelectorAll(
      ':scope > p[data-ps-row-role="title"]'
    );
    const hasSubtitle = cell.querySelector(
      ':scope > p[data-ps-row-role="subtitle"], :scope > .ps-resource-row__subtitle'
    );

    titleParagraphs.forEach((p) => {
      if (p.hasAttribute('data-ps-row-gap')) return;
      // Only strip exit debris between title and subtitle — keep double-Enter staging lines.
      if (hasSubtitle && isEmptyResourceRowTitleParagraph(p)) {
        p.remove();
      }
    });

    const subtitle = cell.querySelector(
      ':scope > p[data-ps-row-role="subtitle"], :scope > .ps-resource-row__subtitle'
    );
    if (subtitle && isEmptyAttributionParagraph(subtitle)) {
      subtitle.remove();
    }
  });

  return template.innerHTML;
}
